/**
 * @file 安全社区
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {Carousel, WingBlank} from 'antd-mobile';
import TopBar from '../../components/TopBar';
import ListPro from '../../components/ListPro';
import Loading from '../../components/Loading';

import {fetchCmsapiIndexData, fetchCmsapiPublish} from '../../actions/forumAction';

import './index.less';

class Forum extends Component {
    static propTypes = {
        fetchCmsapiIndexData: PropTypes.func,
        fetchCmsapiPublish: PropTypes.func,
        cmsapiIndexData: PropTypes.object,
        match: PropTypes.object,
        cmsapiPublish: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoading: true,
            loadingClass: false,
            overstep: false,
            loadingMore: true,
            slideLiIndex: parseInt(localStorage.slideLiIndex, 10),
            curPage: 1
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/forum';
        }
    }

    componentDidMount() {
        if (this.isEmptyobj(this.props.cmsapiIndexData)) {
            this.props.fetchCmsapiIndexData().then(() => {
                const cmsapiIndexData = this.props.cmsapiIndexData;
                this.setState({
                    catid: cmsapiIndexData.itemlist.article_list.catid,
                    slideLiIndex: 0
                });
                localStorage.setItem('slideLiIndex', 0);
                this.sildeTabTop();
            });
        }

        window.addEventListener('scroll', () => this.sildeTabTop());
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.sildeTabTop());
    }

    sildeTabTop() {
        const {sildeBox, topBar} = this;
        let docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (sildeBox) {
            if (docScrollTop >= (sildeBox.offsetTop - topBar.offsetHeight) && !this.state.overstep) {
                this.setState({
                    overstep: true
                });
            } else if (docScrollTop < (sildeBox.offsetTop - topBar.offsetHeight) && this.state.overstep) {
                this.setState({
                    overstep: false
                });
            }
        }
    }

    slideTab(obj) {
        const sildeBox = this.sildeBox;
        this.setState({
            slideLiIndex: obj.index,
            curPage: obj.page,
            catid: obj.catid,
            loadingMore: false
        });
        localStorage.setItem('slideLiIndex', obj.index);
        if (this.state.overstep) {
            document.documentElement.scrollTop = document.body.scrollTop = sildeBox.offsetTop - sildeBox.offsetHeight;
        }

        this.props.fetchCmsapiPublish(obj.catid, obj.page).then(() => {
            const cmsapiPublish = this.props.cmsapiPublish;
            this.setState({
                loadingMore: cmsapiPublish.total_page > cmsapiPublish.cur_page
            });
        });
    }

    fetchPublish() {
        const {catid, curPage} = this.state;
        this.setState({
            loadingMore: false
        });

        this.props.fetchCmsapiPublish(catid, curPage + 1, true).then(() => {
            const cmsapiPublish = this.props.cmsapiPublish;
            this.setState({
                curPage: cmsapiPublish.cur_page,
                loadingMore: cmsapiPublish.total_page > cmsapiPublish.cur_page
            });
        });

    }

    render() {
        this.shareWX({
            title: '百度安全社区-有AI更安全',
            content: ' '
        });
        const {cmsapiIndexData, cmsapiPublish} = this.props;
        const {loadingMore, slideLiIndex, overstep} = this.state;

        let slideClass = classNames({
            'section pr z-index-1': true,
            'slide-fixed': overstep
        });
        let banner = [];
        let isMore = true;

        if (!this.isEmptyobj(cmsapiIndexData)) {
            const itemlist = cmsapiIndexData.itemlist;
            banner.push(...itemlist.big_banner.datalist, ...itemlist.small_banner.datalist);
        }

        if (!this.isEmptyobj(cmsapiPublish)) {
            if (cmsapiPublish.total_page > cmsapiPublish.cur_page) {
                isMore = true;
            } else {
                isMore = false;
            }
        }

        return (
            <div className={'forum'}>
                {!this.isPC()
                    ? <div className={'top-bar-box'} ref={el => this.topBar = el}>
                        <TopBar />
                    </div>
                    : ''
                }

                <div className={'pt130'}>
                    {banner.length
                        ? <WingBlank>
                            <Carousel
                                autoplay={true}
                                autoplayInterval={4000}
                                infinite
                            >
                                {banner.map(val => (
                                    <a
                                        key={val}
                                        href={val.aid
                                            ? `/m/forum/page/${val.aid}`
                                            : (val.address && `/m${val.address}` || '')}
                                        target={'_black'}
                                    >
                                        <img src={val.pic} alt={val.title} width={'100%'} />
                                        <div className={'banner-shade'}>
                                            <span>
                                                {val.title}
                                            </span>
                                        </div>
                                    </a>
                                ))}
                            </Carousel>
                        </WingBlank>
                        : ''
                    }
                </div>

                <div style={{height: '1.3rem', overflow: 'hidden'}} ref={el => this.sildeBox = el}>
                    <div className={slideClass}>
                        {!this.isEmptyobj(cmsapiIndexData) && cmsapiIndexData.itemlist.category.length > 2
                            ? <div>
                                <div className={'shade-left'}></div>
                                <div className={'shade-right'}></div>
                            </div>
                            : null
                        }

                        {!this.isEmptyobj(cmsapiIndexData)
                            ? <div className={'slide'}>
                                <ul>
                                    {
                                        <li
                                            className={slideLiIndex === 0 ? 'on' : ''}
                                            onClick={this.slideTab.bind(this, {
                                                index: 0,
                                                catid: 0,
                                                page: 1
                                            })}>
                                            热门推荐
                                        </li>
                                    }

                                    {
                                        cmsapiIndexData.itemlist.category.map((item, index) => {
                                            return <li
                                                className={slideLiIndex === (index + 1) ? 'on' : ''}
                                                key={index}
                                                onClick={this.slideTab.bind(this, {
                                                    index: index + 1,
                                                    catid: item.catid,
                                                    page: 1
                                                })}>
                                                {item.title}
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                            : ''
                        }
                    </div>
                </div>

                <div className={'page-box'}>
                    {!this.isEmptyobj(cmsapiPublish)
                        ? cmsapiPublish.datalist.map((item, index) => {
                            return <a
                                key={index}
                                href={`/m/forum/page/${item.aid}`}
                                className={'section'}
                                target={'_black'}
                            >
                                <ListPro
                                    title={item.title}
                                    time={item.publish_time.slice(5, 10)}
                                    brief={`${item.pv}人阅读`}
                                    imgSrc={item.pic}
                                />
                            </a>;
                        })
                        : ''
                    }
                </div>
                {!this.isEmptyobj(cmsapiPublish)
                    ? <Loading
                        type={isMore}
                        isLoad={loadingMore}
                        callbackFn={this.fetchPublish.bind(this)}
                        style={{paddingTop: '0.6rem', paddingBottom: '0.8rem'}}
                        ref={el => this.loading = el}
                    />
                    : ''
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cmsapiIndexData: state.cmsapiIndexData,
        cmsapiPublish: state.cmsapiPublish
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiIndexData: () => fetchCmsapiIndexData(dispatch),
        fetchCmsapiPublish: (catid, page, isMore) => fetchCmsapiPublish(dispatch, catid, page, isMore)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Forum);



// WEBPACK FOOTER //
// ./src/containers/forum/index.js